import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter, distinctUntilChanged } from "rxjs/operators";
import { BreadcrumbService } from "../../services/breadcrumb.service";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Array<{ label: string; url: string }>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadCrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
   this.breadcrumbs = this.breadCrumbService.getBreadcrumbs();
   this.router.events
     .pipe(
       filter((event) => event instanceof NavigationEnd, distinctUntilChanged())
     )
     .subscribe(() => {
       this.updateBreadcrumbs();
     });
  }

  private updateBreadcrumbs() {
    this.breadcrumbs = this.createBreadcrumbs(
      this.activatedRoute.root,
      this.breadCrumbService.getBreadcrumbs()
    );
    this.breadCrumbService.setBreadcrumbs(this.breadcrumbs);
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    breadcrumbs: any[],
    url: string = ""
  ): Array<{ label: string; url: string }> {
    const children: ActivatedRoute[] = route.children;

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join("/");
      if (routeURL !== "") {
        url += `/${routeURL}`;
      }

      if (url === "/portal" || url === "") {
        breadcrumbs = [];
        return this.createBreadcrumbs(child, breadcrumbs, url);
      } else {
        const label = child.snapshot.data["breadcrumb"];
        let breadCrumbsArray = [];
        if (label) {
          breadCrumbsArray = label.split(" > ").map((label) => {
            return {
              label: label,
              url: url,
            };
          });
        }

        breadcrumbs = breadCrumbsArray;

         return this.createBreadcrumbs(child, breadcrumbs, url);
      }
    }
    return breadcrumbs;
  }
}
